"use client";
import { useLocation } from "react-router-dom";
import { useTrial } from "@/context/TrialContext";
import { ReactNode } from "react";
import styles from "./TrialGuard.module.scss";

// During an expired trial the user may only see /dashboard (read-only).
// All other pages render a locked overlay instead.
const ALLOWED_PATHS = ["/dashboard", "/"];

export default function TrialGuard({ children }: { children: ReactNode }) {
  const { isTrial, isTrialExpired } = useTrial();
  const { pathname } = useLocation();

  if (!isTrial || !isTrialExpired) return <>{children}</>;

  const isAllowed = ALLOWED_PATHS.some(
    (p) => pathname === p || pathname.startsWith(p + "/"),
  );

  if (!isAllowed) {
    return (
      <div className={styles.lockedPage}>
        <div className={styles.lockedCard}>
          <span className={styles.lockIcon}>🔒</span>
          <h2>Trial Expired</h2>
          <p>
            Your 7-day free trial has ended. This section is no longer
            accessible. Please contact us to upgrade your plan.
          </p>
        </div>
      </div>
    );
  }

  // Dashboard is accessible but wrapped in a read-only overlay hint
  return (
    <div className={styles.readOnlyWrapper}>
      <div className={styles.readOnlyOverlay} aria-hidden="true" />
      {children}
    </div>
  );
}
